// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDyfQFiJVJie0sbgOCa0xy3vhl9Js84u8k",
  authDomain: "riddim-rapids-259de.firebaseapp.com",
  projectId: "riddim-rapids-259de",
  storageBucket: "riddim-rapids-259de.appspot.com",
  messagingSenderId: "39982236589",
  appId: "1:39982236589:web:1afca7cde9fff227231724",
  measurementId: "G-GSNJM5SKZ4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage, getAnalytics };